import BudgetsManagement from '../sections/budgets/BudgetsManagement';
import { useAdminToast } from '../shell/AdminToastContext';

export const UsuariosPage = () => {
    const toast = useAdminToast();
    return <BudgetsManagement toast={toast} />;
};

export default UsuariosPage;
